import axios from "axios";

export default {
  name: "userInformationSection",
  data() {
    return {
      firstName: "",
      lastName: "",
      Email: "",
      date: "",
      linkInsta: "",
      linkFb: "",
    };
  },
  mounted() {
   setTimeout(() => {
      console.log("userInfo", this.$store.getters.getUserInfo);
      this.firstName = this.$store.getters.getUserInfo.firstName;
      this.lastName = this.$store.getters.getUserInfo.lastName;
      this.Email = this.$store.getters.getUserInfo.email;
      if (this.$store.getters.getUserInfo.dateOfBirth) {
        var dateUser = new Date(this.$store.getters.getUserInfo.dateOfBirth);
        var day = dateUser.getDate();
        var month = dateUser.getMonth();
        var years = dateUser.getFullYear();
        // this.date = years + "-" + this.filterDate(month) + "-" + this.filterDate(day);
        this.date =
        years  + "-" + this.filterDate(month) + "-" + this.filterDate(day);
      }
      console.log(this.date)
      this.linkInsta = this.$store.getters.getUserInfo.instagramProfileLink;
      this.linkFb = this.$store.getters.getUserInfo.facebookProfileLink;
    }, 500);
  },
  methods: {
    filterDate(valueToChange) {
      if (valueToChange >= 0 && valueToChange <= 9) {
        valueToChange = "0" + valueToChange.toString();
      }
      return valueToChange;
    },
    updateProfile() {
      var userId = {
        userId: window.localStorage.getItem("Giftstore-U"),
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        dateOfBirth: this.date,
        facebookProfileLink: this.linkFb,
        instagramProfileLink: this.linkInsta,
      };
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/updateProfile",
          userId
        )
        .then((response) => {
          this.$store.commit("setUserInfo", response.data.user);
          this.$toast.open({
            message: "Compte bien modifier",
            type: "success",
            position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Erreur lors de la modification",
            type: "error",
            position: "top-right",
            // all of other options may go here
          });
        });
    },
  },
};
